import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatCheckboxChange} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { TechnologyoverlayService } from '../../../technologyoverlay.service';
import { duplicateBuilding } from '../../../technologyoverlay';
import { takeUntil } from 'rxjs/operators';
import { SessionCheck, generateAlertMessage, AuthFailedMessage,getFeatureNeedtoShow } from '../../../../../app-general';
import { enumUIFeatureView, enumUIAction, enumUIView,appsettings} from '../../../../../app-settings';
import { ApiService } from '../../../../../api.service';
import { getCampus, getZone } from '../../../../../api';
import {Router} from '@angular/router';


@Component({
  selector: 'app-duplicate-building',
  templateUrl: './duplicate-building.component.html',
  styleUrls: ['./duplicate-building.component.scss']
})
export class DuplicateBuildingComponent implements OnInit {

public buildDuplicateForm : FormGroup;
campusInfo; 
builidngInfo; 
selectedCampus; 
watcher: Subscription;
columns = 4;
firstcolumns = 2;
minheight = "350px"; 
rowHeight = "79px";
buildingid;
Floorinfo;
SiteId = "1";
private _onDestroy: Subject<void> = new Subject<void>();
selectedAll: any;
checkfloorinfo = false;
checkfloorselectall = false;
select_FloorIds = [];
Campusdetails;
selectedCampusId;
floorcountchecked_id = 0
bAddEdit:boolean=false;
bDelete:boolean=false;
isCheckedAll = false;

constructor(private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<DuplicateBuildingComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
private technologyoverlayService: TechnologyoverlayService, public dialog: MatDialog,private apiService: ApiService) {
    
    this.builidngInfo = data.BuildingData;
    
    this.campusInfo = data.CampusInfo;
    this.selectedCampusId = data.CampusId;
    this.buildingid = this.builidngInfo[0].BuildId;
    
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change) {
        if (change.mqAlias == 'xs') {
          this.columns = 2;  
          this.firstcolumns = 1;                  
          this.minheight = "auto";
        } 
        else if (change.mqAlias == 'sm') {
          this.columns = 2;
          this.firstcolumns = 2;     
          this.minheight = "auto";
        }  
        else if (change.mqAlias == 'md') {
          this.columns = 2;  
          this.firstcolumns = 1; 
          this.minheight = "350px";               
        }               
       else
       {
         this.columns = 4;  
         this.firstcolumns = 2;      
         this.minheight = "350px";               
       }
      }
    
    });
    
   }
    
  ngOnInit() {
    
    if (getFeatureNeedtoShow(enumUIFeatureView.Technology,enumUIAction.Device_Map_AddEditDelete) == enumUIView.Show) {
      this.bAddEdit = true;
      this.bDelete = true;
    }   

    this.buildDuplicateForm = new FormGroup({
      campusID: new FormControl(''),
      buildID: new FormControl(''),
      buildingname: new FormControl(''),    
      campus : new FormControl('', [Validators.required]),    
      newbuildingname:new FormControl('', [Validators.required, Validators.maxLength(32), Validators.pattern(appsettings.Name_Pattern)]),
      description: new FormControl('', [Validators.pattern(appsettings.Name_Pattern)]),
    });
    
    this.buildDuplicateForm.get('buildingname').disable();
    // this.buildDuplicateForm.get('campusname').disable();
    this.getCampusDetails();
    this.isCheckedAll = true;
    this.getZonedetails()
  }
  
  getCampusDetails()
{
  try
    {
      let campusid: getCampus = {
        siteId : this.SiteId,
        authKey: localStorage.getItem("Authkey")
      }
      this.apiService.getCampusDetails(campusid).pipe(takeUntil(this._onDestroy))
      .subscribe((CampusDetails : any[])=>{  
        
        this.Campusdetails = CampusDetails["apiReturn"];       
      });  
    }
    catch (err) {
      throw new Error('duplicate-building.component.ts' + ' - getCampusDetails() - ' + err.message);
    }
} 

changecampus_duplicate(campusid)
{
  this.selectedCampusId = campusid;
}
  
getZonedetails()
{
  try
  {
    let buildbyid : getZone =  
    { 
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      campusId:this.selectedCampusId,
      buildId: parseInt(this.buildingid),
      floorId : 0
    }
    this.apiService.getZoneDetails(buildbyid).pipe(takeUntil(this._onDestroy))
      .subscribe((floorinfo: any[]) => {        
        this.Floorinfo = floorinfo["apiReturn"];     
        this.toggleAll(this.isCheckedAll) 
    });
  }
  catch (err) {
    throw new Error('duplicate-building.component.ts' + ' - getZonedetails() - ' + err.message);
  }
}
  
  toggleAll(event: any) {

    if (event.checked || event == true) {
      this.select_FloorIds = [];
      this.Floorinfo.forEach(row => {
    
        var checkedid = row.ZoneId
        this.select_FloorIds.push(checkedid)
      });     
    } 
    else {
     
      this.select_FloorIds = [];
      this.select_FloorIds.length = 0;
    }
    this.isCheckedAll = this.isChecked();
  }

  togglefloorVisibility(checkedid, event: MatCheckboxChange) {
    if (event.checked) {
      const index = this.select_FloorIds.indexOf(checkedid);
      if (index == -1) {
        this.select_FloorIds.push(checkedid);
      }
    } else {
      const index = this.select_FloorIds.indexOf(checkedid);
      if (index >= 0) {
        this.select_FloorIds.splice(index, 1);
      }
    }
    this.isCheckedAll = this.isChecked();
    
  }

  exists(checkedid) {
    return this.select_FloorIds.indexOf(checkedid) > -1;
  };

  isChecked() {
    return this.select_FloorIds.length === this.Floorinfo.length;
  };

public onCloseCancel = () => 
  { 
    this.thisDialogRef.close('Cancel');  
    if(!SessionCheck(this.router))
    {
        return;
    }         
         
  }

handleInput(event) 
{
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.buildDuplicateForm.controls).forEach(field => { // {1}
        const control = this.buildDuplicateForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('add-campus.component.ts' + ' - handleInput() - ' + err.message);
    }
}

public duplicatebuildDetails = (duplicatebuildformvalue) => 
  {

    try
    {
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
        return;
      } 
      (document.activeElement as HTMLTextAreaElement).blur();
      if (this.buildDuplicateForm.valid) { 
        this.duplicateBuilding(duplicatebuildformvalue)
      }
    }
    catch(err)
    {
      throw new Error('duplicate-building.component.ts' + ' - duplicatebuildDetails() - ' + err.message);
    }
  }

  //Duplicate building window will show the selected building name and have the option to select the Campus name, New Building name, New building description. On the right side we can choose the Zones we want to have for the duplicating.
  duplicateBuilding(duplicatebuildformvalue)
  {
    try
    {
      let saveclick = document.getElementById('btnduplicatesaveclick');
      if (this.select_FloorIds.length==0 && this.Floorinfo.length>0)
      {
        generateAlertMessage(this.dialog, 'Must add at least one Zone to create as a new Building'); 
        saveclick.className = 'clsdupbuildsavebutton mat-raised-button';  
       return ;
      }
      if (this.select_FloorIds.length==0 && this.Floorinfo.length==0)
      {
        generateAlertMessage(this.dialog, 'Must add at least one Zone to duplicate or create as a Template.');  
        saveclick.className = 'clsdupbuildsavebutton mat-raised-button'; 
        return ;  
      }
          
          saveclick.className = 'clsdupbuildsavebutton mat-raised-button disablebtn';
        let duplicatebuild: duplicateBuilding = {
          siteId:this.SiteId,
          authKey:localStorage.getItem("Authkey"),
          campusId:parseInt(duplicatebuildformvalue.campusID),
          buildingId:parseInt(duplicatebuildformvalue.buildID),
          newCampusId:parseInt(this.selectedCampusId),
          newBuildingName:duplicatebuildformvalue.newbuildingname.toString(),
          newBuildingDescription:duplicatebuildformvalue.description.toString(),
          floorIds:this.select_FloorIds.toString()
        }      
        
        this.technologyoverlayService.duplicateBuilding(duplicatebuild).pipe(takeUntil(this._onDestroy))      
        .subscribe((apiresponse: any[]) => 
        {        
        
          if(parseInt(apiresponse["apiResponse"]) > 0)//if(apiresponse["BuildingId"] > 0)
            {
              saveclick.className = 'clsdupbuildsavebutton mat-raised-button';
              this.thisDialogRef.close(apiresponse["apiResponse"]);
            }
            else if(apiresponse["apiResponse"].toString() == "false")
            {
              generateAlertMessage(this.dialog, 'Building Duplicate added failed.');    
              saveclick.className = 'clsdupbuildsavebutton mat-raised-button';   
              this.thisDialogRef.close("close"); 
            }
            else if(apiresponse["apiResponse"] == "Invalid Auth Key")
            {    
                this.thisDialogRef.close('Cancel');              
                AuthFailedMessage(this.dialog,this.router);  
                return;       
            }
            else
            {            
              generateAlertMessage(this.dialog, "Building name '" + apiresponse["apiResponse"][0].BuildingName + "' already exists.");              
              saveclick.className = 'clsdupbuildsavebutton mat-raised-button';
              return; 
            }
        })
      }
    
    catch(err)
    {
      throw new Error('duplicate-building.component.ts' + ' - duplicateBuilding() - ' + err.message);
    }
  }
  
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

}
